import { render } from "./EmailVerification.vue?vue&type=template&id=b4b81e90&scoped=true"
import script from "./EmailVerification.vue?vue&type=script&lang=js"
export * from "./EmailVerification.vue?vue&type=script&lang=js"

import "./EmailVerification.vue?vue&type=style&index=0&id=b4b81e90&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b4b81e90"]])

export default __exports__